import styled from "@mui/material/styles/styled";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";

const ControlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip
    {...props}
    enterDelay={1500}
    classes={{ popper: className }}
    placement="top"
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    fontFamily: theme.typography.fontFamilySecondary,
    backgroundColor: theme.palette.shades.neutral[800],
    color: "#fff",
    boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.1)",
    fontSize: "0.875rem",
    fontWeight: 500,
    lineHeight: "20px",
    padding: "2px 6px",
  },
}));

export default ControlTooltip;
